import { useMemo } from "react";

import { DrawerType } from "../models";
import { useDrawers } from "./use-drawers";

export const useUserActionsHistoryBell = () => {
  const { openDrawer, drawers } = useDrawers();
  const isUserActionsHistoryDrawerOpened = useMemo(() => {
    return Boolean(
      drawers.find(
        ({ drawerProps: { type } }) => type === DrawerType.UserActionsHistory,
      ),
    );
  }, [drawers]);

  const onMenuItemClick = (): void => {
    if (isUserActionsHistoryDrawerOpened) {
      return;
    }

    openDrawer({
      drawerProps: { type: DrawerType.UserActionsHistory },
    });
  };

  return { onMenuItemClick, isUserActionsHistoryDrawerOpened };
};
